import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Form, Formik, Field } from "formik";
import NipSelect from "../NipInput/NipSelect";
import Button from "../Button/Button";
import XmlSection from "../XmlViewer/XmlViewer";
import generateNumber from "../../utils/Functions/GenerateRandomNo";
import { opt } from "../../utils/Functions/Opt";
import NipDisabled from "../NipInput/NipDisabled";
import formatDate from "../../utils/Functions/FormatDate";
import SwitchSection from "../Toggle/SwitchSection";
import { StatusQuerySchema } from "../../utils/validation";
import XmlCovert from "../../utils/Functions/XmlCoverter";

const StatusQuery = (props) => {
  const {
    goToNameEnquiry,
    goToFundTransfer,
    isSending,
    sendSuccess,
    sendStatusQueryValues,
    statusQueryData,
    clearSuccessState,
    fundTransferData,
  } = props;

  const [state, setState] = useState({
    statusQuery: {},
    retryCheck: false,
  });

  let newTimeStamp = formatDate();
  useEffect(() => {
    generateNumber(setState, state);
    // eslint-disable-next-line
  }, []);

  const enquiryData = fundTransferData && XmlCovert(fundTransferData);
  const parsedData = enquiryData && JSON.parse(enquiryData);
  const fixedData = parsedData && parsedData.FTSingleCreditResponse;
  const sourceCode =
    fixedData && fixedData.SessionID && fixedData.SessionID._text;

  const defaultValues = {
    session_id: process.env.REACT_APP_API_SESSION_ID,
    channel_code: process.env.REACT_APP_API_CHANNEL_CODE,
  };

  const fixedValues = {
    session_id: sourceCode,
    time_stamp: newTimeStamp,
    sourceInstitutionCode: process.env.REACT_APP_API_SESSION_ID,
  };

  const setDefaultValues = () => {
    setState({
      statusQuery: defaultValues,
      random_number: state.random_number,
    });
  };

  const removeDefaultValues = () => {
    setState({
      statusQuery: {},
      random_number: state.random_number,
    });
  };

  const resetForm = () => {
    clearSuccessState();
    setState({
      statusQuery: {},
      retryCheck: true,
      random_number: state.random_number,
    });
  };

  const initialValues = {
    sendersFinancialInstitutionCode: fixedValues.session_id || "",
    sourceInstitutionCode: fixedValues.sourceInstitutionCode || "",
    channelCode: state.statusQuery.channel_code || "",
    randomNumber: "",
    timeStamp: "",
  };

  const handleSubmit = (values) => {
    const name = "transfer-status-query";
    const payload = {
      sourceInstitutionCode: values.sourceInstitutionCode,
      channelCode: values.channelCode,
      fTSingleCreditSessionId: sourceCode
    };
    sendStatusQueryValues(name, payload);
  };

  const xml = (values) => {
    const updateXml = `<?xml version='1.0' encoding='UTF-8'?><TSQuerySingleRequest><SourceInstitutionCode>${
      initialValues.sourceInstitutionCode || values.sourceInstitutionCode
    }</SourceInstitutionCode><ChannelCode>${
      initialValues.channelCode || values.channelCode
    }</ChannelCode><SessionID>${
      initialValues.sendersFinancialInstitutionCode ||
      values.sendersFinancialInstitutionCode
    }</SessionID></TSQuerySingleRequest>`;
    return updateXml;
  };

  const xmlSuccess = statusQueryData && statusQueryData;

  return (
    <div>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={StatusQuerySchema}
      >
        {({ values }) => {
          const disable =
            values.sendersFinancialInstitutionCode === "" ||
            values.channelCode === "";
          return (
            <Form id="form">
              <div className="nip-home-interaction-env">
                <div className="nip-home-interaction-env-left">
                  <SwitchSection
                    name="Transaction Status Query"
                    goToFunction={goToFundTransfer}
                    setDefaultValues={setDefaultValues}
                    removeDefaultValues={removeDefaultValues}
                    retryCheck={state.retryCheck}
                  />

                  <div className="nip-form">
                    <Field
                      name="sourceInstitutionCode"
                      label="Source Institution Code"
                      component={NipDisabled}
                    />
                    <Field name="channelCode">
                      {(val) => (
                        <NipSelect
                          label="Channel Code"
                          placeholder="Select Channel Code"
                          options={opt}
                          {...val}
                        />
                      )}
                    </Field>
                    <Field
                      name="sendersFinancialInstitutionCode"
                      label="Session ID"
                      component={NipDisabled}
                    />
                    {!sendSuccess ? (
                      <Button
                        testId="submitSQ"
                        type="submit"
                        onClick={() => handleSubmit(values)}
                        width="100%"
                        height="45px"
                        disabled={disable || isSending}
                        word={isSending ? "SENDING..." : "SEND REQUEST"}
                      />
                    ) : (
                      <Button
                        testId="proceedToNE"
                        type="button"
                        width="100%"
                        height="45px"
                        onClick={() => goToNameEnquiry()}
                        word={"RESTART"}
                      />
                    )}
                  </div>
                </div>

                <XmlSection
                  xml={sendSuccess ? xmlSuccess : xml(values)}
                  url={"api.nibss.com/transaction/initialize"}
                  onClick={() => resetForm()}
                />
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

StatusQuery.propTypes = {
  clearSuccessState: PropTypes.func,
  fundTransferData: PropTypes.func,
  getSuccess: PropTypes.bool,
  goToFundTransfer: PropTypes.func,
  goToNameEnquiry: PropTypes.func,
  isGetting: PropTypes.bool,
  isSending: PropTypes.bool,
  sendStatusQueryValues: PropTypes.func,
  sendSuccess: PropTypes.bool,
  statusQueryData: PropTypes.any,
  statusQueryValues: PropTypes.any,
};

export default StatusQuery;
